import i18n from '@/i18n';

export function useNumberFormat(value: number): string {
  return i18n.n(value);
}
